var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-search"},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":"https://static.max-c.com/static/heybox/webapp/game/palworld/database/footer.png"}})])])
}]

export { render, staticRenderFns }